/**
 * Pipeline types for ATS.
 */

export interface PipelineRound {
  id: string;
  name: string;
  round_type: string;
  order: number;
}

export interface Pipeline {
  id: string;
  name: string;
  rounds: PipelineRound[];
  created_at: string;
}

export interface PipelineCreateInput {
  name: string;
  rounds?: PipelineRoundCreateInput[];
}

export interface PipelineUpdateInput {
  name?: string;
}

export interface PipelineListData {
  items: Pipeline[];
  total: number;
}

export interface PipelineResponse {
  success: boolean;
  data: Pipeline;
  message: string;
}

export interface PipelineListResponse {
  success: boolean;
  data: PipelineListData;
  message: string;
}

// Round CRUD types

export interface PipelineRoundCreateInput {
  name: string;
  round_type: string;
}

export interface PipelineRoundUpdateInput {
  name?: string;
  round_type?: string;
}

export interface PipelineRoundResponse {
  success: boolean;
  data: PipelineRound;
  message: string;
}

export interface ReorderRoundsResponse {
  success: boolean;
  data: PipelineRound[];
  message: string;
}

// Round type options for dropdown
export const ROUND_TYPE_OPTIONS = [
  { value: 'application_received', label: 'Application Received' },
  { value: 'screening', label: 'Screening' },
  { value: 'test', label: 'Test' },
  { value: 'interview', label: 'Interview' },
  { value: 'offer_sent', label: 'Offer Sent' },
  { value: 'offer_accepted', label: 'Offer Accepted' },
  { value: 'hired', label: 'Hired' },
] as const;

export type RoundTypeValue = (typeof ROUND_TYPE_OPTIONS)[number]['value'];

// Helper function to get label for a round type
export function getRoundTypeLabel(roundType: string): string {
  const option = ROUND_TYPE_OPTIONS.find((opt) => opt.value === roundType);
  return option?.label || roundType;
}
